import { useState } from "react";
import { api } from "@/lib/api";

export function ApplyForm({ position, onDone, requireCv = false }) {
  const [note, setNote] = useState({ cls: "", text: "" });
  const [sending, setSending] = useState(false);
  const [cvName, setCvName] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    const f = e.target;
    const cvFile = f.cv?.files?.[0];
    if (requireCv && !cvFile) {
      setNote({ cls: "err", text: "Carica il tuo CV (PDF o Word) per candidarti a questa posizione." });
      return;
    }
    setSending(true);
    setNote({ cls: "", text: "Invio in corso..." });
    try {
      let cv_path = "";
      let cv_name = "";
      if (cvFile) {
        const fd = new FormData();
        fd.append("file", cvFile);
        const up = await api.post("/upload-cv", fd, { headers: { "Content-Type": "multipart/form-data" } });
        cv_path = up.data.path;
        cv_name = up.data.filename;
      }
      const { data } = await api.post("/contact", {
        tipo: "Candidatura — Lavora con noi",
        nome: f.nome.value,
        email: f.email.value,
        telefono: f.telefono.value,
        residenza: f.residenza.value,
        posizione: position || "Candidatura spontanea",
        cv_path,
        cv_name,
        messaggio: f.messaggio.value,
      });
      setNote({ cls: "ok", text: data.message });
      f.reset();
      setCvName("");
      if (onDone) setTimeout(onDone, 1600);
    } catch (err) {
      const d = err.response?.data?.detail;
      setNote({ cls: "err", text: typeof d === "string" ? d : "Errore nell'invio. Riprova più tardi." });
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="apply-form">
      <div className="field"><label>Nome e Cognome *</label><input name="nome" required placeholder="Mario Rossi" data-testid="apply-nome" /></div>
      <div className="field"><label>Luogo in cui vivi *</label><input name="residenza" required placeholder="Es. Napoli (NA)" data-testid="apply-residenza" /></div>
      <div className="field"><label>Numero di telefono *</label><input name="telefono" required placeholder="+39 333 1234567" data-testid="apply-telefono" /></div>
      <div className="field"><label>Indirizzo email *</label><input name="email" type="email" required placeholder="mario@esempio.it" data-testid="apply-email" /></div>
      <div className="field">
        <label>Curriculum Vitae {requireCv ? "*" : "(facoltativo)"}</label>
        <input name="cv" type="file" accept=".pdf,.doc,.docx" required={requireCv} onChange={(e) => setCvName(e.target.files?.[0]?.name || "")} data-testid="apply-cv" />
        <span style={{ fontSize: ".8rem", color: "var(--ink-soft)" }}>{cvName ? `File: ${cvName}` : "Formati accettati: PDF, DOC, DOCX (max 10MB)"}</span>
      </div>
      <div className="field"><label>Presentazione (facoltativa)</label><textarea name="messaggio" rows="3" placeholder="Parlaci di te e della tua esperienza..." data-testid="apply-messaggio" /></div>
      <button className="btn full" disabled={sending} data-testid="apply-submit">Invia candidatura</button>
      {note.text && <p className={`form-note ${note.cls}`} data-testid="apply-note">{note.text}</p>}
    </form>
  );
}

export function ApplyModal({ job, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose} data-testid="apply-modal">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Chiudi" data-testid="apply-modal-close">×</button>
        <span className="eyebrow">Candidatura</span>
        <h3 className="modal-title">{job.title}</h3>
        <div className="job-tags" style={{ marginBottom: 18 }}>
          {job.location && <span className="job-tag">📍 {job.location}</span>}
          {job.type && <span className="job-tag">🕒 {job.type}</span>}
        </div>
        <ApplyForm position={job.title} onDone={onClose} requireCv={true} />
      </div>
    </div>
  );
}
